module.exports = __webpack_public_path__ + "img/fenxiang.27e9dde7.png";